var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoChatsEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.795 8.81494L37.0312 14.236L43.0967 63.2029L88.9538 60.0143L107.417 68.5592L105.051 53.9322L110.453 53.093L104.795 8.81494Z",
    fill: "#9CA3AF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112.76 54.8288L107.426 55.6574L110.081 72.0728L88.5665 62.1156L41.2837 65.4034L34.7114 12.3455L106.597 6.59473L112.76 54.8288ZM39.3504 16.1265L44.909 61.0023L89.3403 57.913L104.752 65.0456L102.676 52.207L108.144 51.3573L102.992 11.0352L39.3504 16.1265Z",
    fill: "#9CA3AF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M108.343 8.51929L43.6035 13.6984L46.6444 62.9072L92.5084 55.5229L106.685 66.8105L105.051 53.9322L114 52.7973L108.343 8.51929Z",
    fill: "#DBEAFE"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.315 54.5898L107.364 55.7249L109.378 71.6006L91.9341 57.7113L44.7191 65.3133L41.4121 11.7976L110.145 6.29907L116.315 54.5898ZM45.7939 15.5992L48.5686 60.5012L93.0817 53.3344L103.991 62.0204L102.738 52.1395L111.684 51.0048L106.54 10.7395L45.7939 15.5992Z",
    fill: "#9CA3AF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6495 35.5116C99.3249 35.5116 101.494 33.3427 101.494 30.6673C101.494 27.9919 99.3249 25.823 96.6495 25.823C93.974 25.823 91.8052 27.9919 91.8052 30.6673C91.8052 33.3427 93.974 35.5116 96.6495 35.5116Z",
    fill: "#9CA3AF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.73 38.8524C61.4055 38.8524 63.5743 36.6836 63.5743 34.0081C63.5743 31.3327 61.4055 29.1638 58.73 29.1638C56.0546 29.1638 53.8857 31.3327 53.8857 34.0081C53.8857 36.6836 56.0546 38.8524 58.73 38.8524Z",
    fill: "#9CA3AF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M77.69 37.182C80.3654 37.182 82.5343 35.0131 82.5343 32.3377C82.5343 29.6623 80.3654 27.4934 77.69 27.4934C75.0146 27.4934 72.8457 29.6623 72.8457 32.3377C72.8457 35.0131 75.0146 37.182 77.69 37.182Z",
    fill: "#9CA3AF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1389 53.3632L74.1216 42.2183L83.6105 88.0499L37.355 92.3479L26.4452 106.817L24.812 93.9385L15.8632 95.0734L10.1389 53.3632Z",
    fill: "#9CA3AF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1061 89.8964L38.4567 94.3238L25.0326 112.128L23.0192 96.2517L14.0914 97.3841L7.81714 51.6669L75.7416 39.8354L86.1061 89.8964ZM12.4605 55.0593L17.6349 92.7625L26.6045 91.6251L27.8576 101.506L36.253 90.3719L81.1148 86.2033L72.5015 44.601L12.4605 55.0593Z",
    fill: "#9CA3AF"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M6 53.9545L69.9827 42.8096L79.4716 88.6413L37.355 92.3479L23.4597 111.481L20.9264 96.0707L10.1389 97.3982L6 53.9545Z",
    fill: "#9CA3AF"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M81.9696 90.4989L38.4756 94.3266L22.2218 116.707L19.2067 98.3673L8.28068 99.7119L3.7583 52.2443L71.6028 40.4268L81.9696 90.4989ZM8.24178 55.6645L11.9974 95.0844L22.6461 93.7739L24.6978 106.254L36.2346 90.369L76.9736 86.7836L68.3627 45.1923L8.24178 55.6645Z",
    fill: "#9CA3AF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1389 53.3632L74.1216 42.2183L83.6105 88.0499L37.355 92.3479L26.4452 106.817L24.812 93.9385L15.8632 95.0734L10.1389 53.3632Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1061 89.8964L38.4567 94.3238L25.0326 112.128L23.0192 96.2517L14.0914 97.3841L7.81714 51.6669L75.7416 39.8354L86.1061 89.8964ZM12.4605 55.0593L17.6349 92.7625L26.6045 91.6251L27.8576 101.506L36.253 90.3719L81.1148 86.2033L72.5015 44.601L12.4605 55.0593Z",
    fill: "#9CA3AF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2189 57.3538L27.0478 63.1673L26.4082 59.0781L63.5793 53.2646L64.2189 57.3538Z",
    fill: "#9CA3AF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3578 69.9837L20.4182 76.4984L19.8491 72.3988L66.7887 65.884L67.3578 69.9837Z",
    fill: "#9CA3AF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M67.3552 80.4117L49.1474 82.9173L48.583 78.817L66.7909 76.3113L67.3552 80.4117Z",
    fill: "#9CA3AF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoChatsEmpty);
export default __webpack_public_path__ + "static/media/noChatsEmpty.6da1f68b08edd6d4fa55e34652635996.svg";
export { ForwardRef as ReactComponent };